import { SystemChecksheetAssignmentProjection } from '@completion/models';
import { SystemAction, SystemActionTypes } from '@completion/actions';

export const initialState: SystemState = {
  systemScopeOfWork: [],
  currentSystemId: null,
};

export interface SystemState {
  systemScopeOfWork: SystemChecksheetAssignmentProjection[];
  currentSystemId: number | null;
}

export function systemReducer(state: SystemState = initialState, action: SystemAction): SystemState {
  switch (action.type) {
    case SystemActionTypes.LoadSystemScopeOfWork:
      return {
        ...state,
        currentSystemId: action.systemId,
      };
    case SystemActionTypes.LoadSystemScopeOfWorkSuccess:
      return {
        ...state,
        systemScopeOfWork: action.scopeOfWork,
      };

    default:
      return state;
  }
}
